import axios from "axios";
import {authHeader} from "@/helpers/authservice/auth-header";
import Swal from "sweetalert2";
import {log} from "./log";
import {defineStore} from "pinia";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

const offers_endpoint = "/api/orders-manager/offer";
const settings_endpoint = "/api/settings";

export const useOrdersManagerModule = defineStore("ordersManagerModule", {
    state: () => ({
        lazyLoaderModule: useLazyLoaderModule(),
        stock_endpoint: "/api/orders-manager/stock",
        //Common
        backendModuleName: "ORDERS",
        //User data
        user: {},
        //Offers
        offers: [],
        offersPagesCount: 0,
        //Settings
        settings: [],

    }),
    getters: {
        //Common
        getBackendModuleName: (state) => state.backendModuleName,
        //Orders
        getOrdersManagerOffers: (state) => state.offers,
        getOrdersManagerOffersPagesCount: (state) => state.offersPagesCount,
        getOrdersManagerSettings: (state) => state.settings,
    },
        actions: {
            // Mutations
            setOrdersManagerOffers(offers) {
                this.offers = offers;
            },
            setOrdersManagerOffersPagesCount(pagesCount) {
                this.offersPagesCount = pagesCount;
            },
            setOrdersManagerSettings(settings) {
                this.settings = settings;
            },
            // Actions
            httpGetOrdersManagerOffersPaging(payload) {
                var pageNumber = payload.currentPage;
                var filterRequestObject = payload.filterSettingsObject;
                var endpoint = offers_endpoint + "/pages/all?page=" + pageNumber;
                if (payload.sortingKey) {
                    endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
                }
                if (payload.sortingDirection) {
                    endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
                }

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: {
                        Authorization: authHeader(),
                        appToken: "abc",
                    },
                    data: filterRequestObject,
                })
                    .then((response) => {
                        if (response.status === 200) {
                            this.setOrdersManagerOffersPagesCount(
                                response.data.payload.totalPages
                            );
                            this.setOrdersManagerOffers(response.data.payload.content);
                        } else if (response.status === 203) {
                            log.log(response);
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                    });
            },

            httpGetOrdersManagerOffersPagesCount() {
                const endpoint = offers_endpoint + "/pages/total";
                return axios
                    .get(endpoint, {
                        headers: {
                            Authorization: authHeader(),
                            appToken: "abc",
                        },
                        data: {},
                    })
                    .then((response) => {
                        log.log(response);
                        if (response.status === 200) {
                            this.setOrdersManagerOffersPagesCount(response.data.payload);
                        } else if (response.status === 203) {
                            log.log(response);
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                    });
            },

            httpUpdateOrdersManagerOffers(payload) {
                var offersUpdateEndpoint = payload.offersUpdateEndpoint;
                var enableKamsoftOffersUpdate = payload.enableKamsoftOfferUpdate;

                var endpoint = offers_endpoint + offersUpdateEndpoint;
                if (enableKamsoftOffersUpdate) {
                    endpoint = endpoint + "?enableKamsoftOfferUpdate=true";
                }
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: {
                        Authorization: authHeader(),
                        appToken: "abc",
                    },
                    data: {},
                })
                    .then((response) => {
                        if (response.status === 200) {
                            Swal.fire("Dobra robota", "Oferty zaktualizowane pomyślnie", "success");
                        } else if (response.status === 203) {
                            log.log(response);
                            Swal.fire("Coś jest nie tak", response.data.message, "warning");
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                    });
            },

            httpCalculateStockStandardForType(payload) {
                var productsList = payload.productList;
                var productsType = payload.productsType;

                var data = {};
                var endpoint = this.stock_endpoint + "/calculateStockStandard/" + productsType;
                if (productsList) {
                    endpoint = endpoint + "/list";
                    data = productsList;
                } else {
                    endpoint = endpoint + "/all";
                }

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: {
                        Authorization: authHeader(),
                        appToken: "abc",
                    },
                    data: data,
                })
                    .then((response) => {
                        if (response.status === 200) {
                            Swal.fire("Dobra robota", "Normy zaktualizowane pomyślnie", "success");
                        } else if (response.status === 203) {
                            log.log(response);
                            Swal.fire("Coś jest nie tak!", response.message, "warning");

                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                    });
            },

            //Settings
            httpGetOrdersManagerSettings(payload) {
                var endpoint = settings_endpoint + "/module/" + this.backendModuleName;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: {
                        Authorization: authHeader(),
                        appToken: "abc",
                    },
                    data: payload,
                })
                    .then((response) => {
                        if (response.status === 200) {
                            log.log("Displaying settings payload:");
                            log.log(response.data.payload);
                            this.setOrdersManagerSettings(response.data.payload);
                        } else if (response.status === 203) {
                            log.log(response);
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                    });
            },
        }




});
